// src/pages/Successstories.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Successstories() {
  const navigate = useNavigate();

  const caseStudies = [
    {
      id: 1,
      title: "Casestudy 01: Family First Cleaning",
      link: "https://www.reflexadvisor.com/cleaningcasestudy",
      thumbnail: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/cleaningthumbnailreflexadvisor.jpg",
      type: "external",
    },
    {
      id: 2,
      title: "Casestudy 02: North Shore Roofing",
      link: "https://www.reflexadvisor.com/roofingcasestudy",
      thumbnail: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/roofingthumbnailreflexadvisor.jpg",
      type: "external",
    },
    {
      id: 3,
      title: "Casestudy 03: Productize Accelerator",
      link: "https://www.reflexadvisor.com/keanucasestudy",
      thumbnail: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/keanureflexadvisor.png",
      type: "external",
    },
    {
      id: 4,
      title: "Casestudy 04: Hive Local",
      link: "https://www.reflexadvisor.com/hlcasestudy",
      thumbnail: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/hlthumbnailreflexadvisor.jpg",
      type: "external",
    },
    {
      id: 5,
      title: "Casestudy 05: KwikWire",
      link: "/kwikwire",
      thumbnail: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/kwikwire.jpg",
      type: "internal",
    },

    {
  id: 6,
  title: "Casestudy 06: Toronto Junk Disposal",
  link: "/torontojunkdisposalcasestudy",
  thumbnail: "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/junkremoval.png",
  type: "internal",
},
  ];

  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);

  const handleClick = (cs) => {
    if (cs.type === "internal") {
      navigate(cs.link);
    } else {
      window.open(cs.link, "_blank");
    }
  };

  return (
    <div style={styles.pageContainer}>
      {/* Section 1 */}
      <section style={styles.section}>
        <div style={styles.contentWrapper}>
          <div style={styles.textSide}>
            <h1 style={styles.heading}>
              Discover How We've Helped Businesses Grow
            </h1>
            <p style={styles.bodyText}>
              We have been honoured to work with businesses worldwide to take their projects to the next level.
            </p>
          </div>
          <div style={styles.imageSide}>
            <img
              src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/story.png"
              alt="Our Story"
              style={styles.image}
            />
          </div>
        </div>
      </section>

      {/* Section 2 */}
      <section style={styles.sectionWhite}>
        <h2 style={styles.headingCenter}>Featured Casestudies</h2>
        <p style={styles.noticeText}>
          Explore our featured case studies, complete with real results, proofs, and detailed insights.
        </p>

        <div style={styles.gridWrapper}>
          {caseStudies.map((cs) => (
            <div
              key={cs.id}
              style={{
                ...styles.card,
                transform: hoveredCard === cs.id ? "scale(1.05)" : "scale(1)",
                boxShadow:
                  hoveredCard === cs.id
                    ? "0 10px 25px rgba(0,0,0,0.25)"
                    : "0 4px 12px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={() => setHoveredCard(cs.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <img
                src={cs.thumbnail}
                alt={cs.title}
                style={{
                  ...styles.cardImage,
                  transform: hoveredCard === cs.id ? "scale(1.05)" : "scale(1)",
                }}
              />
              <div style={styles.cardContent}>
                <div style={styles.cardText}>{cs.title}</div>

                <button
                  style={{
                    ...styles.viewButton,
                    backgroundColor:
                      hoveredButton === cs.id ? "#5a0fa6" : "#7b19bc",
                    transform:
                      hoveredButton === cs.id ? "scale(0.97)" : "scale(1)",
                  }}
                  onMouseEnter={() => setHoveredButton(cs.id)}
                  onMouseLeave={() => setHoveredButton(null)}
                  onClick={() => handleClick(cs)}
                >
                  View Case Study
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

const styles = {
  pageContainer: {
    width: "100%",
    backgroundColor: "#000",
    color: "#fff",
    fontFamily: "'Elza', sans-serif",
    display: "flex",
    flexDirection: "column",
  },
  section: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "120px 20px",
    backgroundColor: "#000",
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "60px",
    flexWrap: "wrap",
  },
  textSide: {
    flex: "1 1 50%",
    textAlign: "left",
  },
  imageSide: {
    flex: "1 1 45%",
    display: "flex",
    justifyContent: "center",
  },
  image: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "12px",
  },
  sectionWhite: {
    width: "100%",
    backgroundColor: "#fff",
    textAlign: "center",
    padding: "120px 20px",
    color: "#000",
  },
  heading: {
    fontSize: "50px",
    fontWeight: "400",
    lineHeight: "1.2",
    marginBottom: "24px",
    letterSpacing: "-0.5px",
  },
  headingCenter: {
    fontSize: "70px",
    fontWeight: "700",
    lineHeight: "1.1",
    letterSpacing: "-1px",
    textAlign: "center",
    marginBottom: "40px",
    color: "#000",
  },
  bodyText: {
    fontSize: "18px",
    lineHeight: "1.6",
    color: "#cfd2da",
    maxWidth: "600px",
  },
  noticeText: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "60px",
    fontStyle: "italic",
  },
  gridWrapper: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "30px",
    justifyItems: "center",
  },
  card: {
    backgroundColor: "#f8f8f8",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "400px",
    cursor: "pointer",
    overflow: "hidden",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  cardContent: {
    padding: "15px",
  },
  cardImage: {
    width: "100%",
    height: "220px",
    display: "block",
    objectFit: "cover",
    borderRadius: "12px 12px 0 0",
    transition: "transform 0.3s ease",
  },
  cardText: {
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "10px",
    color: "#000",
  },
  viewButton: {
    padding: "8px 18px",
    fontSize: "13px",
    fontWeight: "bold",
    backgroundColor: "#7b19bc",
    color: "#fff",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "block",
    margin: "0 auto",
  },
};